/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumAllegatoRichiestaDTOTipoAllegato =
  (typeof EnumAllegatoRichiestaDTOTipoAllegato)[keyof typeof EnumAllegatoRichiestaDTOTipoAllegato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumAllegatoRichiestaDTOTipoAllegato = {
  GENERICO: 'GENERICO',
  PROCURA: 'PROCURA',
  PAGAMENTO: 'PAGAMENTO',
  RICEVUTA_PAGAMENTO_NON_PROTOCOLLABILE:
    'RICEVUTA_PAGAMENTO_NON_PROTOCOLLABILE',
  RIEPILOGO_RICHIESTA: 'RIEPILOGO_RICHIESTA',
  RIEPILOGO_XML: 'RIEPILOGO_XML',
} as const;
